import { ACTION_VALUES } from './constants';

export function resolveSettingValue(setting, settings, changes) {
    if (setting.id in changes) return changes[setting.id];
    if (setting.id in settings) return settings[setting.id];
    return setting.default;
}

// Selecting the originally-saved value removes the pending change so Save re-disables.
export function applyChange(changes, settings, id, value) {
    const next = { ...changes };
    if (id in settings && settings[id] === value) {
        delete next[id];
    } else {
        next[id] = value;
    }
    return next;
}

export function hasPendingChanges(changes) {
    return Object.keys(changes).length > 0;
}

// Admins outside an organization may not save a Reject action.
export function computeImpersonatingWarning(changes, rejectSaveDisabled) {
    if (!rejectSaveDisabled) return false;
    return Object.values(changes).some(value => value === ACTION_VALUES.REJECT);
}

export function getVisibleSettings(catalog, betaHiddenFlags = {}) {
    return catalog.filter(setting => setting.visible || !betaHiddenFlags[setting.id]);
}

export function isChangeToReject(changes, id) {
    return id in changes && changes[id] === ACTION_VALUES.REJECT;
}

export function isPublisherBlacklistVisible(betaHiddenFlags = {}) {
    return !betaHiddenFlags.blacklisted_publishers;
}

export function hasPublisherBlacklists(blacklists, betaHiddenFlags = {}) {
    return isPublisherBlacklistVisible(betaHiddenFlags) && Array.isArray(blacklists) && blacklists.length > 0;
}

export function summarizeAndroidValidation(androidValidation) {
    const data = androidValidation || {};
    return {
        withKeyCount: (data.sites_with_keys || []).length,
        withoutKeyCount: (data.sites_without_keys || []).length,
        notSupportingKeyCount: (data.not_supporting_sites || []).length,
    };
}

export function triggerFileDownload(contents, filename) {
    const blob = contents instanceof Blob ? contents : new Blob([contents], { type: 'text/csv' });
    const objectUrl = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = filename || 'file.csv';
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.URL.revokeObjectURL(objectUrl);
}
